import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class DivisionService {

  constructor(
    private http: MiraieService,
  ) { }


  /**
   * 事業部一覧取得
   */
  getDivisionList() {
    var url = "division/list";

    return this.http.get(url);
  }

  updateDivisionList(division) {
    var url = "division/update";

    return this.http.post(url, division);
  }

  insertDivision(divi) {
    var url = "division/insert";

    return this.http.post(url, divi);
  }

  deleteDivision(division_code) {
    var url = "division/delete";
    let param = { code: division_code }

    return this.http.post(url, param);
  }
}
